import { render, staticRenderFns } from "./live-chat.vue?vue&type=template&id=77851cdc&scoped=true&"
import script from "./live-chat.ts?vue&type=script&lang=ts&"
export * from "./live-chat.ts?vue&type=script&lang=ts&"
import style0 from "./live-chat.scss?vue&type=style&index=0&id=77851cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77851cdc",
  null
  
)

component.options.__file = "live-chat.vue"
export default component.exports